"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlPrefixNotDefinedException = void 0;
const ts_error_1 = __importDefault(require("ts-error"));
class UrlPrefixNotDefinedException extends ts_error_1.default {
    constructor(tenant) {
        super(`No url prefix found for "${tenant}" tenant`);
        this.tenant = tenant;
    }
}
exports.UrlPrefixNotDefinedException = UrlPrefixNotDefinedException;
//# sourceMappingURL=url-prefix-not-defined.exception.js.map